import React from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { useTranslation } from 'react-i18next';

const FilePreviewModal = ({ fileUrl, onClose }) => {
        const { t } = useTranslation();
    const isPdf = fileUrl.startsWith('data:application/pdf');

    return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="bg-white p-4 rounded-lg max-w-sm w-full">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-bold">{t('file_preview')} </h2>
                <button onClick={onClose} className="text-red-500 w-8 bg-[#F7941D] text-white py-1 px-2 rounded hover:bg-yellow-600">X</button>
            </div>
            <div className="overflow-auto max-h-64">
                {isPdf ? (
                    <Worker workerUrl={`https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js`}>
                        <Viewer fileUrl={fileUrl} />
                    </Worker>
                ) : (
                    <img src={fileUrl} alt="Preview" className="w-full" />
                )}
            </div>
        </div>
    </div>
);
};

export default FilePreviewModal;